var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_link-2",
    "data-name": "vuesax/outline/link-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.516,
    height: 26.516,
    viewBox: "0 0 26.516 26.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.179,12.5A7.176,7.176,0,0,1,2.1.251.828.828,0,0,1,3.267,1.422a5.513,5.513,0,1,0,7.811-.011A.828.828,0,1,1,12.25.24a7.2,7.2,0,0,1,0,10.164A7.106,7.106,0,0,1,7.179,12.5Z",
    transform: "translate(2.754 11.25)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.142,12.962a.819.819,0,0,1-.586-.243.834.834,0,0,1,0-1.171,5.8,5.8,0,1,0-8.2,0,.828.828,0,0,1-1.171,1.171,7.457,7.457,0,1,1,10.551.011A.883.883,0,0,1,12.142,12.962Z",
    transform: "translate(8.927 2.682)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H26.516V26.516H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.02bf601e22b197953d20cac48a8b831a.svg";
export { ForwardRef as ReactComponent };